export default __webpack_public_path__ + "static/media/04_photo.ea0d6c5e.jpg";